import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';
import AuthorisationValues from '../../ValueObjects/AuthorisationValues';
import { IAuthorisable } from '../../IAuthorisable';

export default class ProductType extends TemporalEntity implements IAuthorisable {
    static typeName = "ProductType";

    constructor() {
        super();
        this.makeObservable();
    }

    public productTypeId: number = 0;

    @Rules.Required()
    @Rules.StringLength(20)
    public productTypeCode: string = "";

    @Rules.Required()
    @Rules.StringLength(120)
    @Attributes.DisplayMember()
    public productTypeName: string = "";

    public filterParentInvestment: boolean = false;

    public allowImmediateNotice: boolean = false;

    @Attributes.ChildObject(AuthorisationValues, true)
    public authorisation: AuthorisationValues = new AuthorisationValues();

    public isPendingDelete: boolean = false;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<ProductType>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.productTypeCode) {
            return "New product type";
        } else {
            return this.productTypeCode;
        }
    }
}